<!-- 新版轻骑兵首页 -->
<template>
  <div class="home">
    <!-- Header -->
    <Header @openForm="openForm" :isPageScroll="isPageScroll" :headColor="headColor" :router="'Product'"></Header>
    <!-- banner -->
    <div class="banner-bg">
      <div class="banner-box">
        <div class="banner-con">
          <div class="banner-title">轻骑兵<div style="font-size: 20px;vertical-align: super;line-height: 20px">®</div>低代码开发平台</div>
          <div class="banner-desc">
            让软件开发更简单
          </div>
          <div class="banner-btn">
            <div class="banner-btn-appointment" @click="openForm">预约体验</div>
            <div class="banner-btn-expert" @click="openForm">联系行业专家</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底座 -->
    <div class="model-box">
      <div class="model-title">
        <div style="display: inline-flex">
          轻骑兵<div style="font-size: 17px;line-height: normal;">®</div>低代码开发平台是企业数字化转型的底座
        </div>
      </div>
      <div class="model-desc">支持拖拉拽+快速配置的开发方式，仅需约20%手工开发代码量</div>
      <div class="model-con two-flex">
        <img src="../assets/img/lowCode/two-flex-img1.png">
        <img src="../assets/img/lowCode/two-flex-img2.png">
        <img src="../assets/img/lowCode/two-flex-img3.png">
        <img src="../assets/img/lowCode/two-flex-img4.png">
        <img src="../assets/img/lowCode/two-flex-img5.png" style="position: absolute;top: -80px;left: 1080px;">
        <img src="../assets/img/lowCode/two-flex-img6.png" style="position: absolute;top: -30px;left: 350px;">
      </div>
      <div class="more-btn" @click="openForm" style="position: relative;top: -10px">预约体验</div>
    </div>
    <!-- 架构图 -->
    <div class="model-box base-box">
      <div class="model-title">
        <div style="display: inline-flex">
          基于行业最佳实践，轻骑兵提供高效的低代码解决方案
        </div>
      </div>
      <div class="model-desc">不止于简化代码，轻骑兵重塑开发体验</div>
      <div class="model-con base-con">
        <img class="model-con-img" v-lazy="require('../assets/img/lowCode/base-con-img-new.png')" alt="架构图">
      </div>
      <div class="more-btn" @click="openForm" style="position: relative;top: 0px">预约体验</div>
    </div>
    <!-- 扩展性 -->
    <div class="model-box new-style" style="height: 1000px">
      <div class="model-title">
        <div style="display: inline-flex">
          轻骑兵<div style="font-size: 17px;line-height: normal;">®</div>低代码开发平台 具备很强的扩展性
        </div>
      </div>
      <div class="model-desc">提供多种二次开发方式，为复杂业务场景的开发提供支撑</div>
      <div class="model-con extend-con">
        <ExpendSwiper></ExpendSwiper>
      </div>
      <div class="more-btn" @click="openForm" style="position: relative;top: 30px">预约体验</div>
    </div>
    <!-- 主要功能 -->
    <div class="model-box function-box">
      <div class="model-title">主要功能</div>
      <div class="model-desc">轻骑兵<div style="font-size: 13px;vertical-align: super;line-height: 40px">®</div>是金现代数百名开发工程师历时二十余年倾力打造的一款低代码开发平台</div>
      <div class="model-con function-con">
        <el-tabs v-model="funActiveName">
          <el-tab-pane label="可视化设计器" name="first">
            <div class="fun-tab-con">
              <div class="tab-left">
                <div class="left-title">可视化设计器</div>
                <ul>
                  <li class="clearfix">
                    <span class="fun-li-circle"></span>
                    <span>提供基于拖拽配置式的可视化页面、流程设计器</span>
                  </li>
                  <li class="clearfix">
                    <span class="fun-li-circle"></span>
                    <span>提供扩展组件库、自定义组件库、页面模板库、公共样式库等资源库</span>
                  </li>
                  <li class="clearfix">
                    <span class="fun-li-circle"></span>
                    <span>支持复杂场景下的原型绘制、功能开发、数据库设计、流程设计、移动开发等工作</span>
                  </li>
                  <li class="clearfix">
                    <span class="fun-li-circle"></span>
                    <span>完美还原UI设计效果</span>
                  </li>
                </ul>
                <div class="fun-btn" @click="openForm">预约体验</div>
              </div>
              <div class="tab-right">
                <img src="../assets/img/homePage/function1.gif" class="boxshadow">
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="基础服务平台" name="second">
            <div class="fun-tab-con">
              <div class="tab-left">
                <div class="left-title">基础服务平台</div>
                <ul>
                  <li class="clearfix">
                    <span class="fun-li-circle"></span>
                    <span>包含组织权限中心、门户配置中心、开发者中心等子系统</span>
                  </li>
                  <li class="clearfix">
                    <span class="fun-li-circle"></span>
                    <span>提供组织权限功能服务、系统管理服务、多租户管理服务、任务调度、系统监控、门户配置等功能服务</span>
                  </li>
                </ul>
                <div class="fun-btn" @click="openForm">预约体验</div>
              </div>
              <div class="tab-right">
                <img :src="funcSrc">
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="移动开发平台" name="third">
            <div class="fun-tab-con">
              <div class="tab-left">
                <div class="left-title">移动开发平台</div>
                <ul>
                  <li class="clearfix">
                    <span class="fun-li-circle"></span>
                    <span>支持移动应用可视化开发，快速实现移动业务数据与页面元件的数据绑定</span>
                  </li>
                  <li class="clearfix">
                    <span class="fun-li-circle"></span>
                    <span>支持多种移动开发方式，如原生、混合、H5等</span>
                  </li>
                  <li class="clearfix">
                    <span class="fun-li-circle"></span>
                    <span>支持鸿蒙、安卓、iOS等移动操作系统</span>
                  </li>
                  <li class="clearfix">
                    <span class="fun-li-circle"></span>
                    <span>一套APP代码，多平台通用</span>
                  </li>
                </ul>
                <div class="fun-btn" @click="openForm">预约体验</div>
              </div>
              <div class="tab-right">
                <img src="../assets/img/homePage/function3.gif" class="boxshadow">
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="工作流平台" name="fourth">
            <div class="fun-tab-con">
              <div class="tab-left">
                <div class="left-title">工作流平台</div>
                <ul>
                  <li class="clearfix">
                    <span class="fun-li-circle"></span>
                    <span>流程模型符合BPMN2.0国际标准</span>
                  </li>
                  <li class="clearfix">
                    <span class="fun-li-circle"></span>
                    <span>支持100余项流程接口、20余项中国式流程功能</span>
                  </li>
                  <li class="clearfix">
                    <span class="fun-li-circle"></span>
                    <span>支持流程与表单的可视化权限配置</span>
                  </li>
                </ul>
                <div class="fun-btn" @click="openForm">预约体验</div>
              </div>
              <div class="tab-right">
                <img src="../assets/img/homePage/function4.gif" class="boxshadow">
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 深度定制企业应用 -->
    <div class="model-box value-box">
      <div class="model-title">深度定制企业应用</div>
      <div class="model-con value-con clearfix">
        <ul>
          <li style="margin-right:15px;">
            <div class="value1">
              <p class="value-title">原型开发</p>
              <p class="value-desc">轻骑兵<span style="font-size: 11px;vertical-align: super;line-height: 15px">®</span>低代码开发平台可视化的设计和开发方式使得用户可快速构建出高保真的原型系统，帮助开发人员更快地了解项目需求，以便更好地设计和开发产品。</p>
            </div>
          </li>
          <li style="margin-right:15px;">
            <div class="value2">
              <p class="value-title">企业内部应用</p>
              <p class="value-desc">轻骑兵<span style="font-size: 11px;vertical-align: super;line-height: 15px">®</span>低代码开发平台提供了丰富的内置组件和模板库，帮助开发者快速构建出符合企业实际需求的应用。同时，平台具备强大的集成能力，可与客户现有系统进行集成。</p>
            </div>
          </li>
          <li>
            <div class="value3">
              <p class="value-title">中大型项目</p>
              <p class="value-desc">轻骑兵<span style="font-size: 11px;vertical-align: super;line-height: 15px">®</span>低代码开发平台可减少手动编码、简化开发流程的优点使得轻骑兵低代码开发平台成为需快速开发和部署的中大型项目的理想选择。</p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 按钮 -->
      <div class="more-btn" @click="openForm">预约体验</div>
    </div>
    <!-- 案例 -->
    <div class="model-box case-box" :style="{'background': 'url(' + caseBgList[caseBgIndex].img + ')'}">
      <div class="model-title">案例</div>
      <div class="model-desc">是客户也是伙伴，轻骑兵助力千行百业成功交付<span class="highlighted-number">10000+</span>应用</div>
      <div class="model-con case-con">
        <CaseSwiper @changeBg="changeBg"></CaseSwiper>
        <div class="case-industry">
          <div class="case-industry-title">应用行业</div>
          <ul>
            <li>电力能源</li>
            <li>轨道交通</li>
            <li>航天军工</li>
            <li>石油石化</li>
            <li>智能制造</li>
            <li>冶金冶炼</li>
            <li>证券金融</li>
            <li>移动通信</li>
            <li>工程建筑</li>
            <li>政务服务</li>
            <li>产教融合</li>
            <li>商业服务</li>
          </ul>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="case-more-btn" @click="jumpTo('/CasePage')">了解更多<img src="../assets/img/homePage/case-more.png"></div>
    </div>
    <ContactExperts></ContactExperts>
    <!-- footer -->
    <FhBottom/>
    <!-- 右侧联系方式 -->
    <SideBar @openForm="openForm"></SideBar>
    <!-- 表单 -->
    <HussarForm v-show="showForm" @closeForm="closeForm"></HussarForm>
    <!-- 返回顶部 -->
    <img src="../assets/img/homePage/top.png" class="back-top" @click="backTop" v-if="isPageScroll">
  </div>
</template>

<script>
import HussarForm from './include/HussarForm.vue';
import SideBar from './include/SideBar.vue';
import Header from './include/Header.vue';
import ExpendSwiper from './ExpendSwiper.vue';
import CaseSwiper from './CaseSwiper.vue';
import ContactExperts from './include/ContactExperts.vue';

const function21 = require('../assets/img/homePage/function21.gif');
const function22 = require('../assets/img/homePage/function22.gif');

export default {
  name: "LowCode",
  data() {
    return {
      tabPosition:'top',
      headColor:"dark",
      isPageScroll: false,
      showForm: false,
      isSubmit: false,
      funActiveName: 'first',
      funcSrc: function21,
      caseBgIndex: 0,
      caseBgList: [
        {
          img: require("../assets/img/homePage/case4-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case5-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case6-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case1-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case2-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case3-bg.jpg"),
        },
      ]
    };
  },
  components: {
    ContactExperts,
    Header,
    HussarForm,
    SideBar,
    ExpendSwiper,
    CaseSwiper,
  },
  watch: {
    funActiveName(n) {
      if (n === 'second') {
        this.funcSrc = function21;
        setTimeout(() => {
          this.funcSrc = function22;
        }, 2000);
      }
    }
  },
  methods: {
    // 跳转页面
    jumpTo(page) {
      const self = this;
      self.$router.push({ path: page });
    },
    changeBg(n) {
      const self = this;
      self.caseBgIndex = n;
    },
    openForm() {
      const self = this;
      self.showForm = true;
    },
    closeForm() {
      const self = this;
      self.showForm = false;
    },
    toLink() {
      window.open("http://www.jxdinfo.com");
    },
    // 返回顶部
    backTop() {
      $('html ,body').animate({scrollTop: 0}, 700);
    },
    // 页面滚动
    handleNavScroll() {
      const self = this;
      self.isPageScroll = false;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 80) {
        self.isPageScroll = true;
      }
    },
  },
  mounted() {
    // 视频播放
    var sUserAgent = navigator.userAgent;
    var phoneFlag = sUserAgent.indexOf('Android') > -1 || sUserAgent.indexOf('iPhone') > -1
      || sUserAgent.indexOf('iPad') > -1 || sUserAgent.indexOf('iPod') > -1 || sUserAgent.indexOf('Symbian') > -1;
    if(phoneFlag){
      document.getElementsByTagName('body')[0].classList.add('mobile')
      var oWidth = document.body.clientWidth || document.documentElement.clientWidth;
      document.getElementsByTagName("html")[0].style.fontSize = oWidth/750*100 + "px";
    }
    window.addEventListener('scroll', this.handleNavScroll);
    var ua = navigator.userAgent,
      isWindowsPhone = /(?:Windows Phone)/.test(ua),
      isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid &&       !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
      isPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isPc = !isPhone && !isAndroid && !isSymbian;
    var os = {
      isTablet: isTablet,
      isPhone: isPhone,
      isAndroid: isAndroid,
      isPc: isPc
    };
    if (os.isAndroid || os.isPhone) {
      this.$router.replace({ path: '/lowcodephone' });
    }
  },
  created() {},
};
</script>

<style scoped>
.home {color: #2E2E2E;}
.home >>> .header-con > div a{height: 100%;display: flex;align-items:center;color: #2e2e2e;}
.home >>> .navigator > div a:hover,.navigator .isActive {color: #186CF5;}
.more-btn {position: relative;left: 50%;transform: translateX(-50%);width: 120px;height: 42px;background: #186CF5;border-radius: 5px;font-size: 16px;text-align: center;color: #FFF;line-height: 42px;cursor: pointer;}
.more-btn:hover {background: rgba(21, 132, 243, 0.9);}
.value-btn {position: relative;left: 50%;transform: translateX(-50%);width: 110px;height: 38px;background: #FFF;border-radius: 5px;font-size: 16px;text-align: center;color: #186CF5;line-height: 38px;cursor: pointer;}
.value-btn:hover {background: rgba(255, 255, 255, 0.9);}

/* banner */
.banner-bg{background: linear-gradient(to right, #D5E2EF 0%, #D5E2EF 50%, #CFE1EF 50%, #CFE1EF 100%);}
.banner-box {width: 100%;height: 630px;background: url('../assets/img/lowCode/banner-bg.png') no-repeat; background-size: 100% 100%;}
.banner-con {width: 1200px;margin: 0 auto;padding-top: 205px;}
.banner-title {font-size: 50px;font-weight: bold;line-height: 70px;display: flex}
.banner-desc {display: flex;align-items: center;position: relative;height: 40px;font-size: 28px;font-weight: 400;line-height: 40px;}
.banner-desc img {margin-left: 6px;z-index: 2;width: 45px}
.banner-desc img:hover {transform: scale(1.2);}
.banner-btn {position: relative;margin-top: 54px;cursor: pointer;}
.banner-btn-appointment {display: inline-block;width: 158px;height: 54px;background: linear-gradient(90deg, #018DFF 0%, #1A74F1 100%);border-radius: 5px;color: #FFF;font-size: 18px;text-align: center;line-height: 54px;}
.banner-btn-appointment:hover {background: linear-gradient(90deg, #186CF5 0%, #095EE9 100%);}
.banner-btn-expert {display: inline-block;width: 158px;height: 54px;margin-left: 13px;border: 1px solid #1D79FB;border-radius: 5px;line-height: 54px;color: #1D79FB;font-size: 18px;text-align: center;}
.banner-btn-expert:hover {background: rgba(29, 121, 251, 0.1);}

/*更敏捷*/
.two-flex{margin:50px auto !important;}
.two-flex img{margin: 12px;}

/*现实*/
.base-box{background: linear-gradient(to bottom, #EFF4FF,#FCFDFF)}
.model-box {position: relative;width: 100%;padding: 80px 0 30px 0;}
.model-con {width: 1200px;margin: 0 auto;position: relative;}
.model-con-img {width: 1200px;height: 636px;margin: 50px auto}
.model-title {font-size: 34px;font-weight: bold;text-align: center;line-height: 52px;}
.model-desc {font-size: 22px;text-align: center;line-height: 60px;height: 43px;display: flex;justify-content: center;}

/*新范式*/
.new-style{}
.new-style .model-desc{margin-bottom: 40px}

/* 主要功能 */
.function-box {height: 918px;background: url("../assets/img/lowCode/function-box-bg.png") no-repeat;background-size: 100%}
.function-con {height: 653px;padding-top: 52px;}
.function-con >>> .el-tabs,
.function-con >>> .el-tab-pane,
.fun-tab-con,
.tab-left,
.tab-right {height: 100%;}
.function-con >>> .el-tabs__content {height: calc(100% - 126px);}
.function-con >>> .el-tabs__header {margin-bottom: 68px;}
.function-con >>> .el-tabs__nav-wrap::after {display: none;}
.function-con >>> .el-tabs__active-bar {display: none;}
.function-con >>> .el-tabs__nav {width: 100%;text-align: center;}
.function-con >>> .el-tabs__item {width: 190px;height: 58px;padding: 0;margin-right: 20px;line-height: 58px;text-align: center;font-size: 20px;color: #333;background: #FFF;border-radius: 2px;}
.function-con >>> .el-tabs__item.is-active {color: #FFF;background: #186CF5;}
.tab-left {width: 366px;float: left;position: relative;padding-right: 44px;}
.left-title {margin: 12px 0 58px;font-size: 28px;font-weight: bold;color: #333;line-height: 40px;}
.tab-left ul {font-size: 14px;line-height: 35px;}
/* .tab-left ul li {display: flex;align-items: baseline;justify-content: flex-start;} */
.tab-left ul li span {display: block;float: left;width: calc(100% - 24px);}
.tab-left ul li span.fun-li-circle {display: block;width: 14px;height: 14px;margin-right: 10px;position: relative;
  top: 9px;background: linear-gradient(180deg, #2377FF 0%, #BDD6FF 100%);border-radius: 50%;}
.fun-btn {width: 110px;height: 38px;position: absolute;bottom: 30px;background: #186CF5;border-radius: 5px;line-height: 38px;color: #fff;font-size: 16px;text-align: center;cursor: pointer;}
.fun-btn:hover {background: rgba(21, 132, 243, 0.9);}
.tab-right {width: calc(100% - 366px);float: left;text-align: center;}
.tab-right img.boxshadow {box-shadow: 0 3px 10px 1px rgba(0, 0, 0, .16);}

/* 深度定制企业应用 */
.value-box {height: 600px;}
.value-con {padding-top: 60px;padding-bottom:35px;font-size: 16px;color: #2E2E2E;line-height: 31px;}
.value-con ul li {width: 386px;height: 222px;float: left;margin-bottom: 25px;border-radius: 5px;background:#F7FAFD;color: #2e2e2e;padding: 30px 20px 5px 30px}
.value-con ul li div{float: left;height: 100%;}
.value-con ul li div:nth-child(2){width: 84%;background: #2D6EEB;border-radius: 5px;padding: 20px 5px 10px 20px}
.value-con ul li:nth-child(3n) {margin-right: 0;}
.value-con ul li p.value-title {font-size: 20px;font-weight: bold;margin-bottom: 10px}
.value-con ul li p.value-desc {font-size: 16px;}
.value-box .value1{background: url("../assets/img/lowCode/value-box-white1.png") no-repeat;background-position: right bottom;}
.value-box .value2{background: url("../assets/img/lowCode/value-box-white2.png") no-repeat;background-position: right bottom;}
.value-box .value3{background: url("../assets/img/lowCode/value-box-white3.png") no-repeat;background-position: right bottom;}
.value-con ul li:hover{background: #115CE0;color: #fff}

/* 案例 */
.case-box {height: 800px;transition: background 1s ease;background-repeat: no-repeat !important; background-size: cover !important;}
.case-box .model-title, .case-box .model-desc {color: #FFF;}
.case-con {display: flex;margin-top: 54px;margin-bottom: 40px;}
.case-industry {background: url('../assets/img/homePage/case-industry-bg.png');width: 275px;height: 428px;padding: 16px 39px 0 32px;color: #FFF;}
.case-industry-title {font-size: 20px;font-weight: bold;line-height: 52px;border-bottom: 1px solid #FFF;}
.case-industry ul li {float: left;margin-top: 32px;width: 64px;margin-right: 56px;font-size: 16px;}
.case-industry ul li:nth-child(2n) {margin-right: 0;}
.case-more-btn {background: linear-gradient(90deg, #1A74F1 0%, #018DFF  100%);position: relative;left: 50%;transform: translateX(-50%);width: 105px;height: 44px;border-radius: 5px;font-size: 14px;text-align: center;color: #FFF;line-height: 44px;cursor: pointer;}
.case-more-btn img {margin-left: 3px;transition: all .3s ease;}
.case-more-btn:hover img {transform: translateX(8px);}

/* 返回顶部 */
.back-top {position: fixed;top: calc(40% + 250px);right: 5px;cursor: pointer;}
/*取消页面光标*/
.model-box div,img{caret-color: transparent;}
.highlighted-number {
  font-weight: bold;
  color: #186cf5;
}
</style>



// WEBPACK FOOTER //
// src/components/LowCode.vue